module.exports = __webpack_public_path__ + "img/img2.b0c4aaaf.jpg";